module.exports = __webpack_public_path__ + "static/media/Item_Back_E_00_Lv1_C.0c674474.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Equipment/Backpack/Item_Back_E_00_Lv1_C.png
// module id = 193
// module chunks = 0